import { useAppSelector } from './useAppSelector'

export const useConfiguration = () =>
  useAppSelector((state) => state.configuration)
